export enum SubscriptionFlagValue {
    HoldOpen = 32, // 100000
    HoldUpdate = 16, // 010000
    HoldClose = 8, // 001000
    WipOpen = 4, // 000100
    WipUpdate = 2, // 000010
    WipClose = 1 // 000001
}

export default class Subscription {

    holdOpen: number;
    holdUpdate: number;
    holdClose: number;
    wipOpen: number;
    wipUpdate: number;
    wipClose: number;

    constructor(subscriptionFlag: number){
        this.holdOpen = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.HoldOpen);
        this.holdUpdate = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.HoldUpdate);
        this.holdClose = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.HoldClose);
        this.wipOpen = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.WipOpen);
        this.wipUpdate = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.WipUpdate);
        this.wipClose = this.createSubscriptionDataFromBitFlag(subscriptionFlag, SubscriptionFlagValue.WipClose);
    }

    public createSubscriptionDataFromBitFlag(value: number, flag: number): number {
        if ((flag | value) == value) {
            return flag;
        }
        return 0;
    }

    public createBitFlagFromSubscriptionData(): number {
        return this.holdOpen + this.holdUpdate +
            this.holdClose + this.wipOpen +
            this.wipUpdate + this.wipClose;
    }
}